import * as React from "react";

import { setStorageItem } from "@v2/hooks/useLocalStorage";
import { getBackendStagingNamespace } from "@v2/utils/env";

const BackendStagingBanner: React.FC = () => {
  return (
    <div className="bg-amber-soft/70 header-h6 absolute top-0 left-0 z-max w-full p-2.5 text-center font-bold pointer-events-none">
      🚧 Using Backend Staging: {getBackendStagingNamespace()} 🚧{" "}
      {/* A stack that is asleep or misspelled sends the app to the sign-up page,
          where the Debug menu is out of reach, so the way back lives here. */}
      <button
        type="button"
        className="pointer-events-auto underline"
        onClick={() => {
          setStorageItem("replo.debug.useBackendStaging", "false");
          window.location.reload();
        }}
      >
        Back to production
      </button>
    </div>
  );
};

export default BackendStagingBanner;
